import React, {ReactNode} from 'react';
import {Box} from '@mui/material';

interface Props {
	children: ReactNode;
}

/** Fixed at bottom center; same vertical level as FabAreaWrapperBottomRight (bottom: 40). */
const FabAreaWrapperBottomCenter: React.FC<Props> = ({ children }) => (
	<Box
		zIndex={1000}
		role="presentation"
		sx={{
			position: 'fixed',
			bottom: 40,
			left: '50%',
			transform: 'translateX(-50%)',
		}}
	>
		{children}
	</Box>
);

export default FabAreaWrapperBottomCenter;
